import { render, staticRenderFns } from "./forwardTask.vue?vue&type=template&id=dda93e60&"
import script from "./forwardTask.vue?vue&type=script&lang=js&"
export * from "./forwardTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports